export default __webpack_public_path__ + "static/media/CIRCULATION A VÉLO.558ab284.svg";